import { render } from "./index.vue?vue&type=template&id=624ebdaf&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=624ebdaf&lang=scss&scoped=true"

import exportComponent from "D:\\work\\首页\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-624ebdaf"]])

export default __exports__